import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { ExternalIdListItem } from '@/models/external-id-list/external-id-list-item.model';
import { ExternalIdListFilter } from '@/models/external-id-list/external-id-list-filter.model';
import { clearObj } from '@marfa/bo-utils';
import { RequestListPayload } from '@/models/common/request-list-payload.model';

export class GetSegmentExternalIdListRequest extends ApiResourceMethod<ExternalIdListItem[]> {
  public perform(filterList: RequestListPayload<ExternalIdListFilter>): Promise<ExternalIdListItem[]> {
    return this.performer.requestWithMapper(
      { params: clearObj(filterList) },
      ({ data }: BaseResponse<ExternalIdListItem[]>): ExternalIdListItem[] => data,
    );
  }
}
